"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paddock = void 0;
const datamodel_core_1 = require("@iotv/datamodel-core");
const typeName = 'Paddock';
class Paddock extends datamodel_core_1.Area {
    constructor(ob) {
        var _a, _b, _c;
        super({ ...ob, type: (_a = ob.type) !== null && _a !== void 0 ? _a : typeName });
        this.points = (_b = ob.points) !== null && _b !== void 0 ? _b : [];
        this.pause = (_c = ob.pause) !== null && _c !== void 0 ? _c : false;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                label: 'Name',
                name: 'name',
                description: 'Name of the field',
            },
            type: {
                type: 'String',
                editable: true,
                label: 'Type',
                name: 'type',
                description: 'Type of field eg grazing, crop, fallow',
            },
            points: {
                type: 'object',
                editable: true,
                label: 'Geopoints',
                name: 'Geopoints',
                description: 'External boundaries of field',
            },
        };
    }
}
exports.Paddock = Paddock;
